/**
 * Formulaire de contact
 */

// Si c'est un pro de l'immo, alors on affiche le choix de l'offre pro
$('#form_sendmail #contact-title').change(function() {
    if ($('#contact-title').val() === "Pro de l'immo") {
        $('#contact-div-select-offre').removeClass('d-none');
    } else {
        $('#contact-div-select-offre').addClass('d-none');
        $('#contact-select-offre').val('');
    }
});
